<template>
  <el-row style="width: 100%;">


     <el-select
       :multiple="multiple"
       v-model="user_id"

       placeholder="输入账号、昵称进行搜索"
       filterable
       size="mini"

       clearable
       :loading="loading"
       style="width: 100%">
            <el-option
              v-for="item in user_data"
              :key="item[key_type]"
              :label="item.username+'('+item.nick+')'"
              :value="item[key_type]"
             >
            </el-option>
          </el-select>


  </el-row>

</template>
<script>
  import * as API from "@/api/index.js"
  export default {
     props: {
        data_value:"",

       key_type:{
          type:String,
          default:"userid"
       },   // key、value 的取值key
       multiple:{
          type:Boolean,
         default:false
       },  // 是否多选

       user_options:{
         type:Array,
         default:function () {
           return null
         }
       },

       target_loading:{
         type:Boolean,
         default:false
       },
     },
    model:{
      prop: 'data_value',
      event: 'data_value_change'
    },
     data(){
       return {
         loading:false,
         user_data: [],
         user_id:"",
         search:"",
       }

     },
    mounted(){
       this.user_id = this.data_value
      if (this.user_data.length<=0){
        this.queryUserData()
      }

    },
    watch:{

       user_options(val){
         if(val){
           this.user_data = this.user_options;
         }
       },

       target_loading(val){
         this.loading = val
       },

       data_value:function (val) {
        this.user_id = val
      },


      user_id:function (val) {
        this.$emit("data_value_change",val)
      },
    },
    methods:{

       user_search(search){
         this.search = search

         this.queryUserData()
       },


      async queryUserData(){

        var datas = {"user_namenick":this.search,"user_id":this.user_id}
        this.loading = true
        const response = await API.GET('/omnis/system/user_management/', datas)
        this.loading = false
        if (response && response.data) {
          var data = response.data
           data.data.map(item=>{
             this.user_data.push(item)
           })
        }
      },

     }

  }
</script>



// WEBPACK FOOTER //
// user_select.vue?6aad3046